import { useContext } from 'react';
import { SettingsContex } from 'contexts/settings/settings';

export const useSettings = () => {
  return useContext(SettingsContex);
};
